module.exports = __webpack_public_path__ + "static/solution-section-balls-362cb3593f1c7257948391418c454ad6.png";